import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'haven-loader',
    templateUrl: './app-loader.component.html',
    styleUrls: ['./app-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppLoaderComponent implements OnInit {
  @Input()
  loaderEnabled: boolean = false;
  constructor() {}

  ngOnInit() {}
}
